class FPSizeGuide extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[data-size-guide-open]');
    this.closeButton = this.querySelector('[data-size-guide-close]');
    this.unitButtons = this.querySelectorAll('[data-size-unit]');
    this.panels = this.querySelectorAll('[data-size-panel]');

    this.openButton?.addEventListener('click', () => this.dialog?.showModal());
    this.closeButton?.addEventListener('click', () => this.dialog?.close());
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    this.unitButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectUnit(button.dataset.sizeUnit));
    });
  }

  selectUnit(unit) {
    this.unitButtons.forEach((button) => {
      const selected = button.dataset.sizeUnit === unit;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.sizePanel !== unit;
    });
  }
}

if (!customElements.get('fp-size-guide')) {
  customElements.define('fp-size-guide', FPSizeGuide);
}
